/* Shared reveal for Rugged sections.
   Content is visible by default; the .ru-js class (added inline by each section)
   is what enables the hidden start state. This script's only job is to put it back. */
(function () {
  function revealAll() {
    document.querySelectorAll('.ru__reveal').forEach(function (e) { e.classList.add('is-in'); });
  }
  function init() {
    var els = document.querySelectorAll('.ru__reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
    els.forEach(function (e) { io.observe(e); });

    /* Safety net: if anything is still hidden after 2.5s — an observer edge case,
       a hidden parent at load, a theme-editor re-render — show it anyway. */
    setTimeout(revealAll, 2500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
